import React from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import { useConversations } from '@/shared/hooks/useConversations';
import { ChatWindow } from '@/components/messages/ChatWindow';
import { ChatWindowSkeleton } from '@/components/messages/ChatWindowSkeleton';

/**
 * Full-screen chat page — no TopNavigation or BottomNavigation.
 * ChatWindow provides its own header (back arrow + avatar + name).
 *
 * Route: /messages/:id
 */
const Conversation: React.FC = () => {
  const { id }    = useParams<{ id: string }>();
  const navigate  = useNavigate();
  const { conversations, isLoading } = useConversations();

  if (isLoading) {
    return <ChatWindowSkeleton />;
  }

  const conversation = conversations.find((c) => c.id === id);

  // Conversation not found or user is not a participant — go back to inbox
  if (!conversation) {
    return <Navigate to="/messages" replace />;
  }

  return (
    <div className="w-full" style={{ background: '#160C0C' }}>
      <ChatWindow
        conversation={conversation}
        onBack={() => navigate('/messages')}
      />
    </div>
  );
};

export default Conversation;
